import styled from 'styled-components/macro';

export const ScEmailText = styled.p`
  color: ${({ theme }) => theme.whiteColor};
  margin-bottom: 32px;
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.16px;
  text-align: center;
`;
